export const textsForTariff = [
    {
        title: 'Вы — космонавт',
        description: 'Перемещаетесь сквозь пространство интернета на галактических скоростях, для этого нужен мощный корабль.'
    },
    {
        title: 'Вы — цифровой сёрфер',
        description: 'Всегда на гребне событий и новостей, вам нужна высокая скорость и хороший обзор, чтобы поймать волну.'
    },
    {
        title: 'В доме искусственный интеллект',
        description: 'Искусственный интеллект уже в вашем доме — нужно больше скорости на все киноновинки и игры по сети.'
    }
];
